module.exports = __webpack_public_path__ + "img/185.633744cf.jpg";